import type { ReactNode } from "react";

import { useFeatureFlag } from "hooks/ui/useFeatureFlag";
import PageNotFound from "legacy/pages/common/PageNotFound";
import { Flag } from "store/slices/featureFlags";

/**
 * Gates the redesign's demo/mock admin pages (Overview, Platform Setup,
 * Identity, Database, File Storage, App Analytics, Observability Monitor,
 * Platform MCP, External Auth/Users/Experience).
 *
 * These pages only render when BOTH the nav redesign and the demo-pages flag
 * are on, so the redesigned nav shell + real pages can be shipped (or the mock
 * pages withheld) independently of one another.
 */
export function AdminDemoPagesGuard({ children }: { children: ReactNode }) {
  const navRedesignEnabled = useFeatureFlag(Flag.NAV_REDESIGN_ENABLED);
  const demoPagesEnabled = useFeatureFlag(Flag.ADMIN_DEMO_PAGES_ENABLED);
  return navRedesignEnabled && demoPagesEnabled ? (
    <>{children}</>
  ) : (
    <PageNotFound />
  );
}
